import { CustomModal, POSImage } from '@publicisgroupe/p-os-components';

import './ImageContainerModal.less';

interface ImageContainerModalProps {
  open: boolean;
  onCloseModal: () => void;
  imageContent: string;
  imageText: string;
}

export const ImageContainerModal = ({
  open,
  onCloseModal,
  imageContent,
  imageText,
}: ImageContainerModalProps) => {
  return (
    <CustomModal
      open={open}
      onClose={onCloseModal}
      size="large"
      className="image-container-modal"
      centered
    >
      <CustomModal.Content className="help-section">
        <POSImage src={imageContent} size="large" className="help-section-image" />
        <h6
          className="help-section-image-content"
          dangerouslySetInnerHTML={{ __html: imageText }}
        />
      </CustomModal.Content>
    </CustomModal>
  );
};
